import { snakeCase, startCase } from 'lodash';
import React, { FC } from 'react';
import { Team } from 'api/models/core-types';
import { UsersMetadata } from 'components/organisms/tasks/fields';
import { AssigneeFieldFilter } from 'components/organisms/tasks/filters/assignee';
import { SelectFilterOperationType } from 'components/organisms/tasks/filters/select';
import { TranslationKey, useTranslation } from 'hooks/use-translation';
import { fullName } from 'utils/full-name';
import { removeTrailingDots } from './utils';

const getFilterValues = (
  filter: AssigneeFieldFilter,
  users: UsersMetadata,
  teams: Team[],
) => {
  return filter.type === SelectFilterOperationType.Is ||
    filter.type === SelectFilterOperationType.IsNot ||
    filter.type === SelectFilterOperationType.IsOneOf ||
    filter.type === SelectFilterOperationType.IsNoneOf
    ? (filter.value ?? [])
        .map(([type, x]) => {
          if (type === 'user') {
            return users.non_external_user_ids.find(
              (a) => a === parseInt(x.toString(), 10),
            )
              ? fullName(users.by_user_id[x])
              : null;
          }

          return teams.find((t) => t.teamId === parseInt(x.toString(), 10))
            ?.teamName;
        })
        .filter((x) => Boolean(x))
    : [];
};

export const AssigneeFilterToText: FC<{
  filter: AssigneeFieldFilter;
}> = ({ filter }) => {
  const {
    field: {
      fieldLabel,
      metaData: { users, teams },
    },
    type,
  } = filter;

  return (
    <span>
      {startCase(fieldLabel)}{' '}
      {removeTrailingDots(
        useTranslation(
          `task_list.filters.${snakeCase(type)}` as TranslationKey,
        ),
      )}{' '}
      {getFilterValues(filter, users, teams).join(', ')}
    </span>
  );
};
